import m from 'moment';
import axios from 'axios';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

main();

let localActiveOutlet = localStorage.getItem('active_outlet');
let localActiveOutletCurrency = localStorage.getItem('active_outlet_currency');
let localStartDate = localStorage.getItem('start_date');
let localEndDate = localStorage.getItem('end_date');

let startDate = localStartDate == null ? m().startOf('day') : m(localStartDate);
let endDate = localEndDate == null ? m().endOf('day') : m(localEndDate);

let localStartMonth = localStorage.getItem('start_month');
let localEndMonth = localStorage.getItem('end_month');

let startMonth =
    localStartMonth == null ? m().startOf('month') : m(localStartMonth);
let endMonth =
    localEndMonth == null
        ? m()
              .subtract(1, 'day')
              .endOf('day')
        : m(localEndMonth);

let localStartYear = localStorage.getItem('start_year');
let localEndYear = localStorage.getItem('end_year');

let startYear =
    localStartYear == null ? m().startOf('year') : m(localStartYear);
let endYear =
    localEndYear == null
        ? m()
              .subtract(1, 'day')
              .endOf('day')
        : m(localEndYear);

const state = {
    activeOutlet: localActiveOutlet == null ? 0 : localActiveOutlet,
    activeOutletCurrency: localActiveOutletCurrency || '',
    startDate: startDate,
    endDate: endDate,
    startMonth: startMonth,
    endMonth: endMonth,
    startYear: startYear,
    endYear: endYear,
    outlets: [],
    dateFilter: {
        since: startDate.format(),
        until: endDate.format(),
    },
    monthFilter: {
        since_month: startMonth.format(),
        until_month: endMonth.format(),
    },
    yearFilter: {
        since_year: startYear.format(),
        until_year: endYear.format(),
    },
};

const getters = {
    dateFilter(state) {
        return state.dateFilter;
    },

    monthFilter(state) {
        return state.monthFilter;
    },

    yearFilter(state) {
        return state.yearFilter;
    },

    startDate(state) {
        return state.startDate;
    },

    endDate(state) {
        return state.endDate;
    },

    startMonth(state) {
        return state.startMonth;
    },

    endMonth(state) {
        return state.endMonth;
    },

    startYear(state) {
        return state.startYear;
    },

    endYear(state) {
        return state.endYear;
    },

    activeOutlet(state) {
        return state.activeOutlet;
    },

    activeOutletCurrency(state) {
        return state.activeOutletCurrency;
    },

    currency(state) {
        let currency = state.activeOutletCurrency;

        if (!_.isEmpty(currency) && currency != 'null') {
            if (_.isString(currency)) {
                currency = JSON.parse(currency);
            }

            return currency.symbol;
        }

        return null;
    },

    outletList() {
        return state.outlets;
    },

    findOutletById: state => outlet_id => {
        return state.outlets.find(o => o.id == outlet_id);
    },
};

const mutations = {
    setReportRange(state, range) {
        state.startDate = range.start;
        state.endDate = range.end;

        state.dateFilter = {
            since: state.startDate.format(),
            until: state.endDate.format(),
        };

        localStorage.setItem('start_date', range.start.toISOString());
        localStorage.setItem('end_date', range.end.toISOString());
    },

    setMonthReportRange(state, range) {
        state.startMonth = range.start;
        state.endMonth = range.end;

        state.monthFilter = {
            since_month: state.startMonth.format(),
            until_month: state.endMonth.format(),
        };

        localStorage.setItem('start_month', range.start.toISOString());
        localStorage.setItem('end_month', range.end.toISOString());
    },

    setYearReportRange(state, range) {
        state.startYear = range.start;
        state.endYear = range.end;

        state.yearFilter = {
            since_year: state.startYear.format(),
            until_year: state.endYear.format(),
        };

        localStorage.setItem('start_year', range.start.toISOString());
        localStorage.setItem('end_year', range.end.toISOString());
    },

    setActiveAllOutlets(state) {
        this.setActiveOutlet(state, 0);
    },

    setActiveOutlet(state, id) {
        state.activeOutlet = id;
        localStorage.setItem('active_outlet', id);
        setActiveOutletCurrency(state, id);
    },

    setActiveFirstOutlet(state) {
        if (state.activeOutlet != 0 || !state.outlets) {
            if (_.isEmpty(localStorage.getItem('active_outlet_currency'))) {
                let outlet = state.outlets.find(
                    o => o.id == state.activeOutlet,
                );

                if (!_.isEmpty(outlet) && !_.isEmpty(outlet.currency)) {
                    localStorage.setItem(
                        'active_outlet_currency',
                        JSON.stringify(outlet.currency),
                    );
                }
            }

            return;
        }

        let id = state.outlets[0].id;
        state.activeOutlet = id;
        localStorage.setItem('active_outlet', id);

        setActiveOutletCurrency(state, id);
    },

    setOutletCurrencyIfNecessary(state, id) {
        setActiveOutletCurrency(state, id);
    },

    setOutletList(state, outlets) {
        state.outlets = outlets;
    },

    setActiveFirstOutlet(state) {
        if (state.activeOutlet != 0 || !state.outlets) {
            return;
        }

        let id = state.outlets[0].id;
        state.activeOutlet = id;
        localStorage.setItem('active_outlet', id);
    },
};

const actions = {
    async getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-report-outlet');

        let api = Laroute.route('franchise.vue.outlets');

        return axios.get(api, options).then(res => {
            let data = res.data.data;

            commit('setOutletList', data);
            endLoading(dispatch, 'fetch-report-outlet');

            return data;
        });
    },
};

function main() {
    if (shouldClearLocalStorage()) {
        clearLocalStorage();
    }

    setLastActive();
}

function getLastActive() {
    let lastActive = localStorage.getItem('last_active');

    if (lastActive != null) {
        return m(lastActive);
    }

    return null;
}

function setLastActive() {
    localStorage.setItem('last_active', m().toISOString());
}

function setActiveOutletCurrency(state, outlet_id) {
    if (!hasOutletId(outlet_id)) {
        resetCurrencyValue(state);
        return;
    }

    let outlet = state.outlets.find(o => o.id == outlet_id);

    if (outlet != null) {
        state.activeOutletCurrency = outlet.currency;
        localStorage.setItem(
            'active_outlet_currency',
            JSON.stringify(outlet.currency),
        );
    } else {
        resetCurrencyValue(state);
    }
}

function hasOutletId(id) {
    return id != null && id != 0;
}

function resetCurrencyValue(state) {
    state.activeOutletCurrency = '';
    localStorage.setItem('active_outlet_currency', '');
}

function shouldClearLocalStorage() {
    let lastActive = getLastActive();

    if (lastActive != null) {
        let now = m();
        return now.diff(lastActive, 'hours') > 8;
    }

    return false;
}

function clearLocalStorage() {
    localStorage.removeItem('active_outlet');
    localStorage.removeItem('active_outlet_currency');
    localStorage.removeItem('start_date');
    localStorage.removeItem('end_date');
    localStorage.removeItem('start_year');
    localStorage.removeItem('end_year');
}

export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/report.js